var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CED4DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.334 10.6663C20.0687 10.6663 19.8143 10.7717 19.6267 10.9593L19.0981 11.4879L20.5127 12.9024L21.0412 12.3738C21.2288 12.1862 21.3342 11.9318 21.3342 11.6666C21.3342 11.4013 21.2288 11.1469 21.0412 10.9593C20.8537 10.7717 20.5993 10.6663 20.334 10.6663ZM21.9841 13.3166C22.4217 12.879 22.6675 12.2855 22.6675 11.6666C22.6675 11.0477 22.4217 10.4541 21.9841 10.0165C21.5464 9.57886 20.9529 9.33301 20.334 9.33301C19.7151 9.33301 19.1215 9.57886 18.6839 10.0165L17.6843 11.0161C17.6841 11.0163 17.6844 11.016 17.6843 11.0161C17.6841 11.0163 17.6837 11.0167 17.6836 11.0168L9.52925 19.1712C9.40422 19.2962 9.33398 19.4658 9.33398 19.6426V22.0239C9.33398 22.3921 9.63246 22.6906 10.0007 22.6906H12.334C12.5108 22.6906 12.6804 22.6203 12.8054 22.4953L21.9841 13.3166ZM19.5698 13.8452L18.1553 12.4307L10.6673 19.9187V21.3572H12.0578L19.5698 13.8452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilDisabled);
export default __webpack_public_path__ + "static/media/pencil_disabled.666b7b2d5a35083ae7e2c48cfe69cda9.svg";
export { ForwardRef as ReactComponent };